export const categoryWiseCustomisation = [
  {
    category: "Dining & Arm Chairs",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          }
        ]
      }
    ]
  },
  {
    category: "High Chairs",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          }
        ]
      }
    ]
  },
  {
    category: "Dining and Study Chairs",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          }
        ]
      }
    ]
  },
  {
    category: "Club and Sofa Chairs",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          }
        ]
      }
    ]
  },
  {
    category: "Sofa",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      },
      {
        name: "Pillow",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      }
    ]
  },
  {
    category: "Lounge Chair",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      },
      {
        name: "Backrest",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      }
    ]
  },
  {
    category: "Ottoman",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          }
        ]
      }
    ]
  },
  {
    category: "Chaise and Day Beds",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      },
      {
        name: "Pillow",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      }
    ]
  },
  {
    category: "Swing",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Seat",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      },
      {
        name: "Pillow",
        material: [
          {
            name: "Fabric",
            parentId: "5d7ce0484e8d3c763cf7b4df",
            subMaterialId: "685100a5b7480ab98f6cdd37"
          },
          {
            name: "Leather",
            parentId: "5d7ce0484e8d3c763cf7b4e7",
            subMaterialId: "5d7ce0484e8d3c763cf7b51c"
          }
        ]
      }
    ]
  },
  {
    category: "Dining Table",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      },
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      }
    ]
  },
  {
    category: "Cafe Tables",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Marble",
            parentId: "5d7ce0484e8d3c763cf7b4dd",
            subMaterialId: "5d7ce0484e8d3c763cf7b505"
          }
        ]
      }
    ]
  },
  {
    category: "Study Tables",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Marble",
            parentId: "5d7ce0484e8d3c763cf7b4dd",
            subMaterialId: "5d7ce0484e8d3c763cf7b505"
          }
        ]
      }
    ]
  },
  {
    category: "Open Office Tables",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Marble",
            parentId: "5d7ce0484e8d3c763cf7b4dd",
            subMaterialId: "5d7ce0484e8d3c763cf7b505"
          }
        ]
      }
    ]
  },
  {
    category: "Centre Tables",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Marble",
            parentId: "5d7ce0484e8d3c763cf7b4dd",
            subMaterialId: "5d7ce0484e8d3c763cf7b505"
          }
        ]
      }
    ]
  },
  {
    category: "Side Tables",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Marble",
            parentId: "5d7ce0484e8d3c763cf7b4dd",
            subMaterialId: "5d7ce0484e8d3c763cf7b505"
          }
        ]
      }
    ]
  },
  {
    category: "Workstation",
    parts: [
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Glass",
        material: [
          {
            name: "Glass",
            parentId: "5d7ce0484e8d3c763cf7b4e1",
            subMaterialId: "5d7ce0484e8d3c763cf7b4ed"
          },
        ]
      },
      {
        name: "Leg",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Drawer",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      }
    ]
  },
  {
    category: "Conference and Meeting Tables",
    parts: [
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Leg",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      }
    ]
  },
  {
    category: "Tables",
    parts: [
      {
        name: "Top",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Leg",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      }
    ]
  },
  {
    category: "Console & Passage Units",
    parts: [
      {
        name: "Structure",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Leg",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          },
          {
            name: "Metal",
            parentId: "5d7ce0484e8d3c763cf7b4dc",
            subMaterialId: "685122abb7480ab98f6cdd40"
          }
        ]
      },
      {
        name: "Drawer",
        material: [
          {
            name: "Wood",
            parentId: "5d7ce0484e8d3c763cf7b4de",
            subMaterialId: "68511bd9b7480ab98f6cdd3e"
          }
        ]
      }
    ]
  }
];


export const categoryCustomisation = [
  {
    name: "Wood",
    parentId: "5d7ce0484e8d3c763cf7b4de",
    subMaterialId: "68511bd9b7480ab98f6cdd3e"
  },
  {
    name: "Glass",
    parentId: "5d7ce0484e8d3c763cf7b4e1",
    subMaterialId: "5d7ce0484e8d3c763cf7b4ed"
  },
  {
    name: "Fabric",
    parentId: "5d7ce0484e8d3c763cf7b4df",
    subMaterialId: "685100a5b7480ab98f6cdd37"
  },
  {
    name: "Leather",
    parentId: "5d7ce0484e8d3c763cf7b4e7",
    subMaterialId: "5d7ce0484e8d3c763cf7b51c"
  },
  {
    name: "Metal",
    parentId: "5d7ce0484e8d3c763cf7b4dc",
    subMaterialId: "685122abb7480ab98f6cdd40"
  },
  {
    name: "Marble",
    parentId: "5d7ce0484e8d3c763cf7b4dd",
    subMaterialId: "5d7ce0484e8d3c763cf7b505"
  },
]